var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeNpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 14,
    viewBox: "0 0 37 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_7419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9987 0C33.8648 0 37 3.13467 37 7C37 10.8653 33.8648 14 29.9987 14H7.00125C3.13524 14 0 10.8653 0 7C0 3.13467 3.13524 0 7.00125 0H29.9987Z",
    fill: "#00DE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01277 12.0751C4.20504 12.0751 1.92896 9.80311 1.92896 7.00045C1.92896 4.19778 4.20504 1.92578 7.01277 1.92578C9.82049 1.92578 12.0966 4.19778 12.0966 7.00045C12.0979 9.80311 9.82183 12.0751 7.01277 12.0751ZM7.99454 4.46178V7.25246L6.02968 4.46178H4.47086V9.53646H6.03235V6.74579L7.99721 9.53646H9.55603V4.46178H7.99454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1793 3.77599L30.6726 7.22399L29.0082 3.77599H27.4881L30.0074 8.66932L28.9949 10.936H30.4308L33.6139 3.77599H32.1793ZM25.3683 9.26265H26.7294V3.77465H25.3683V4.22532C24.9008 3.84932 24.3719 3.65332 23.7307 3.65332C22.1826 3.65332 20.9697 4.92265 20.9697 6.51732C20.9697 8.11199 22.1826 9.38132 23.7307 9.38132C24.3719 9.38132 24.9008 9.18532 25.3683 8.80932V9.26265ZM23.9284 8.27065C23.0174 8.27065 22.3322 7.51865 22.3322 6.51999C22.3322 5.52132 23.0188 4.76932 23.9284 4.76932C24.838 4.76932 25.5246 5.52132 25.5246 6.51999C25.5259 7.51732 24.8394 8.27065 23.9284 8.27065ZM15.9126 8.83865C16.3708 9.19732 16.8837 9.38399 17.5022 9.38399C19.0503 9.38399 20.2631 8.11465 20.2631 6.51999C20.2631 4.92532 19.0503 3.65599 17.5022 3.65599C16.861 3.65599 16.332 3.85199 15.8645 4.22799V3.77732H14.5034V10.9373H15.9113V8.83865H15.9126ZM15.7083 6.51999C15.7083 5.52132 16.3948 4.76932 17.3045 4.76932C18.2141 4.76932 18.9007 5.52132 18.9007 6.51999C18.9007 7.51865 18.2141 8.27065 17.3045 8.27065C16.3948 8.27065 15.7083 7.51732 15.7083 6.51999Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_7419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNpay);
export default __webpack_public_path__ + "static/media/badge_npay.67b038d01ddebd1348ca26b985fb20e0.svg";
export { ForwardRef as ReactComponent };